import { render, staticRenderFns } from "./PickTheAnswer.vue?vue&type=template&id=838b94e6&scoped=true&"
import script from "./PickTheAnswer.vue?vue&type=script&lang=ts&"
export * from "./PickTheAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./PickTheAnswer.vue?vue&type=style&index=0&id=838b94e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838b94e6",
  null
  
)

export default component.exports